import { Card } from "@shared/ui/card";
import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import {
  Calendar,
  Smartphone,
  MapPin,
  Shield,
  DollarSign,
  Clock,
  Plus,
  Bookmark,
  Award,
} from "lucide-react";
import { useParams } from "react-router-dom";
// import { useGetFieldForceDetails } from "../../../hooks";
import { format } from "date-fns";
import {
  useCurrency,
  useRemoteUtilityId,
} from "@shared/selectors/globalSelectors";
import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { useMemo, useState } from "react";
import AddSkillsDialog from "../AddSkillsDialog";
import AddCertificatesDialog from "../AddCertificatesDialog";

export const BasicDetail = ({ technician }) => {
  console.warn("techniciannnnnnnnnn", technician);
  const { ff_no } = useParams<{ ff_no: string }>();
  const currency = useCurrency();
  // const { data: technician } = useGetFieldForceDetails(ff_no || "");

  const [openSkills, setOpenSkills] = useState(false);
  const [openCertificates, setOpenCertificates] = useState(false);
  const remoteUtilityId = useRemoteUtilityId();
  const days = [
    { id: "monday", label: "Monday" },
    { id: "tuesday", label: "Tuesday" },
    { id: "wednesday", label: "Wednesday" },
    { id: "thursday", label: "Thursday" },
    { id: "friday", label: "Friday" },
    { id: "saturday", label: "Saturday" },
    { id: "sunday", label: "Sunday" },
  ];
  const infoItems = useMemo(() => {
    return [
      {
        label: "Joining Date",
        value: technician?.joiningDate || "N/A",
        icon: Calendar,
      },
      {
        label: "IMEI Number",
        value: technician?.imeiNumber || "N/A",
        icon: Smartphone,
      },
      {
        label: "Area",
        value: technician?.areaName?.length
          ? technician.areaName.join(", ")
          : "N/A",
        icon: MapPin,
      },
      {
        label: "Sub Area",
        value: technician?.subAreaName?.length
          ? technician.subAreaName.join(", ")
          : "N/A",
        icon: MapPin,
      },
      {
        label: "App Account",
        value: technician?.isUserAccess ? "Enabled" : "Disabled",
        icon: Shield,
        badge: true,
        isActive: technician?.isUserAccess,
      },
    ];
  }, [technician]);

  return (
    <div className="grid grid-cols-12 gap-6">
      {/* Basic Information Card */}
      <div className="col-span-12 lg:col-span-7">
        <Card className="p-6 h-full">
          <h3 className="font-bold text-lg mb-6">Basic Information</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-4 mb-8">
            {infoItems.map((item, index) => (
              <ValueLabel key={index} label={item.label} value={item.value} />
            ))}
          </div>

          <div className="border-t border-gray-100 pt-6 mb-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <Bookmark className="h-5 w-5 text-gray-400" />
                <span className="font-semibold text-gray-900">Skills</span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="h-8 gap-1 text-blue-600 hover:text-blue-700 hover:bg-blue-50"
                onClick={() => setOpenSkills(true)}
              >
                <Plus className="h-4 w-4" /> Add
              </Button>
            </div>
            <div className="flex flex-wrap gap-2">
              {technician?.skillNames?.length > 0 ? (
                technician.skillNames?.map((skill: any, index: number) => (
                  <Badge
                    key={index}
                    variant="secondary"
                    className="bg-gray-100 text-gray-700 hover:bg-gray-200 border-transparent font-normal"
                  >
                    {skill}
                  </Badge>
                ))
              ) : (
                <span className="text-sm text-gray-400 italic">
                  No skills added
                </span>
              )}
            </div>
          </div>

          <div className="border-t border-gray-100 pt-6 mb-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <Award className="h-5 w-5 text-gray-400" />
                <span className="font-semibold text-gray-900">
                  Certifications
                </span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="h-8 gap-1 text-blue-600 hover:text-blue-700 hover:bg-blue-50"
                onClick={() => setOpenCertificates(true)}
              >
                <Plus className="h-4 w-4" /> Add
              </Button>
            </div>
            <div className="flex flex-wrap gap-2">
              {technician?.certificateName?.length > 0 ? (
                technician.certificateName.map((cert: any, index: number) => (
                  <Badge
                    key={index}
                    variant="secondary"
                    className="bg-blue-50 text-blue-700 hover:bg-blue-100 border-blue-100 font-normal"
                  >
                    {cert}
                  </Badge>
                ))
              ) : (
                <span className="text-sm text-gray-400 italic">
                  No certifications added
                </span>
              )}
            </div>
          </div>

          <div className="border-t border-gray-100 pt-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <DollarSign className="h-5 w-5 text-gray-400 mt-0.5" />
                <div>
                  <p className="text-sm font-semibold text-gray-900">
                    Normal Pay Rate
                  </p>
                  <p className="text-sm text-gray-500">
                    {currency} {technician?.additionalData?.normalPay || "0"}
                    /hour
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-gray-400 mt-0.5" />
                <div>
                  <p className="text-sm font-semibold text-gray-900">
                    Overtime Pay Rate
                  </p>
                  <p className="text-sm text-gray-500">
                    {currency} {technician?.additionalData?.overtimePay || "0"}
                    /hour
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* Weekly Availability Card */}
      <div className="col-span-12 lg:col-span-5">
        <Card className="p-6 h-full">
          <h3 className="font-bold text-lg mb-6">Weekly Availability</h3>
          <div className="space-y-3">
            {days.map((day) => {
              const schedule =
                technician?.additionalData?.availabilitySchedule?.find(
                  (item: any) =>
                    item.day.toLowerCase() === day.label.toLowerCase(),
                );

              const isDayOff = schedule?.isWeeklyOff ?? true;

              return (
                <div
                  key={day.id}
                  className={`flex items-center justify-between p-3 rounded-lg border ${
                    !isDayOff
                      ? "bg-blue-50/50 border-blue-100"
                      : "bg-white border-gray-100"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`h-2 w-2 rounded-full ${
                        !isDayOff ? "bg-green-500" : "bg-gray-300"
                      }`}
                    />

                    <span className="font-medium text-gray-900">
                      {day.label}
                    </span>

                    {!isDayOff ? (
                      <div className="flex items-center gap-2 ml-2">
                        <Badge className="bg-blue-600 text-white border-none text-xs h-5">
                          Available
                        </Badge>

                        {schedule?.isOvertime && (
                          <span className="bg-white border border-gray-200 text-gray-600 px-1.5 py-0.5 rounded text-[10px] font-bold uppercase">
                            OT
                          </span>
                        )}
                      </div>
                    ) : (
                      <Badge
                        variant="secondary"
                        className="bg-gray-100 text-gray-500 text-xs h-5 ml-2"
                      >
                        Day Off
                      </Badge>
                    )}
                  </div>

                  {!isDayOff && schedule?.startTime && schedule?.endTime && (
                    <div className="flex items-center gap-3 text-xs text-gray-600">
                      <div className="flex items-center gap-1">
                        <Clock className="h-3 w-3" />
                        <span>
                          {schedule.startTime} - {schedule.endTime}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Card>
      </div>
      <AddSkillsDialog
        open={openSkills}
        onClose={() => setOpenSkills(false)}
        technician={technician}
      />

      <AddCertificatesDialog
        open={openCertificates}
        onClose={() => setOpenCertificates(false)}
        technician={technician}
      />
    </div>
  );
};
